
// Action Types
const SET_FORM_VALUES = "proNewListingForms/setFormValues";
const SET_FORM_ERRORS = "proNewListingForms/setFormErrors";
const SET_FORM_TOUCHED = "proNewListingForms/setFormTouched";
const RESET_ALL_FORMS = "proNewListingForms/resetAllForms";

// Initial State
const initialState = {
  details: { values: {}, errors: [], touched: false },
  scheduling: { values: {}, errors: [], touched: false },
  media: { values: {}, errors: [], touched: false },
  resources: { values: {}, errors: [], touched: false },
  location: { values: {}, errors: [], touched: false },
  digital_waiver: { values: {}, errors: [], touched: false }
};

// Action Creators
export const setFormValues = (tab, values) => ({
  type: SET_FORM_VALUES,
  payload: { tab, values }
});

export const setFormErrors = (tab, errors) => ({
  type: SET_FORM_ERRORS,
  payload: { tab, errors }
});

export const setFormTouched = (tab, touched) => ({
  type: SET_FORM_TOUCHED,
  payload: { tab, touched }
});

export const resetAllForms = () => ({
  type: RESET_ALL_FORMS
});

// Reducer
const proNewListingFormsReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_FORM_VALUES: {
      const { tab, values } = action.payload;
      return {
        ...state,
        [tab]: { ...state[tab], values }
      };
    }
    case SET_FORM_ERRORS: {
      const { tab, errors } = action.payload;
      return {
        ...state,
        [tab]: { ...state[tab], errors }
      };
    }
    case SET_FORM_TOUCHED: {
      const { tab, touched } = action.payload;
      return {
        ...state,
        [tab]: { ...state[tab], touched }
      };
    }
    case RESET_ALL_FORMS:
      return initialState;
    default:
      return state;
  }
};

export default proNewListingFormsReducer;